import { useEffect } from 'react';

export function useScrollTop() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
}

export function useScrollTopOnChange(dependency) {
  useEffect(() => { window.scrollTo(0, 0); }, [dependency]);
}
